/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Reject_ButtonInputs */

const en_admin_registration_reject_button = /** @type {(inputs: Admin_Registration_Reject_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject`)
};

const de_admin_registration_reject_button = /** @type {(inputs: Admin_Registration_Reject_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

/**
* | output |
* | --- |
* | "Reject" |
*
* @param {Admin_Registration_Reject_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_reject_button = /** @type {((inputs?: Admin_Registration_Reject_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Reject_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_reject_button(inputs)
	return en_admin_registration_reject_button(inputs)
});